import { getMarginBottom } from "components/common/inputScales";
import { createThemedUseStylesWithParams } from "theme";

import { Header2Props } from "./Header2Types";

export default createThemedUseStylesWithParams<Header2Props>(
  (params, theme) => ({
    h2: {
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      marginBottom: getMarginBottom(params.stackSpacing, theme)
    }
  })
);
